import styled from 'styled-components';
import { DASHBOARD_STYLED_CONSTS } from '@components/common';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`;
export const TopBar = styled.div `
  display: flex;

  flex-direction: column-reverse;
  gap: var(--space-250);
  align-items: flex-start;

  ${mediaQueries.tablet} {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    padding-right: 0;
  }
`;
export const TopBarLeftContent = styled.div `
  display: flex;
  align-items: start;
  gap: var(--space-250);
`;
export const StatWrapper = styled.div `
  scroll-snap-align: start end;
  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);

  &:last-child {
    padding-right: ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL}px;

    ${mediaQueries.tablet} {
      padding-right: 0;
    }
  }
`;
